import {Component, Input, OnInit, OnChanges, SimpleChanges} from '@angular/core';
import {BaseComponent} from '../../BaseComponent';
import {ActivatedRoute, Router} from '@angular/router';
import {Location} from '@angular/common';
import {UserModel} from '../../../models/UserModel';
import {Platform} from '@ionic/angular';
import {forkJoin, Observable} from 'rxjs';
import {ProviderAnagrafService} from '../../general-services/service-provider-anagraf/provider-anagraf.service';
import {LoaderService} from '../../general-services/service-loader/loader.service';
import {AllSettingsFilterModel} from '../../../models/AllSettingsFilterModel';
import {ProviderModel} from '../../../models/ProviderModel';
import {Offset} from '../../../models/Offset';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent extends BaseComponent implements OnInit, OnChanges {
  user: UserModel;
  mobile: boolean;
  providerData: any;
  providerSelected: any;
  filterSingle: AllSettingsFilterModel;

  @Input() menuLink: string;
  @Input() menuHeader: string;
  @Input() new: string;
  @Input() element: string;
  @Input() title: string;
  @Input() url: string;
  @Input() backUrl: string = null;
  @Input() showBack: boolean;
  @Input() showNew: boolean;


  constructor(route: ActivatedRoute,
              router: Router,
              platform: Platform,
              private loaderService: LoaderService,
              private _location: Location,
              private providerService: ProviderAnagrafService) {
    super(route, router);
    this.user = JSON.parse(sessionStorage.getItem('user'));
    this.mobile = this.checkMobile(platform);
  }

  async ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges) {
    this.url = this.menuHeader
      .split('?')[0]
      .split('/')[1]
      .replace('/', '')
      .replace(/-/gi, ' ');

    if (sessionStorage.getItem(this.SESSION_STORAGE_LABELS.DEFAULT_PROVIDER_SELECTED) === null) {
      this.initProvider();
    } else {
      const reload = true;
      this.initProvider(reload);
    }
  }

  async logout() {
    await sessionStorage.clear();
    this.baseRouter.navigate([this.LINKS.LOGIN]);
  }

  onResize(event) {
    if (event.target.innerWidth <= 1024) {
      this.mobile = true;
    } else {
      this.mobile = false;
    }
  }

  initProvider(reload?: boolean) {
    this.loaderService.display(true);
    this.filterSingle = AllSettingsFilterModel.getFromLogin();
    const getFirstProviderObservable: Observable<any> = this.providerService.getListInAllSettings(
      this.providerService.baseUrl,
      this.filterSingle,
      ).pipe();

    forkJoin([getFirstProviderObservable])
      .subscribe(
        (resultFork: any) => {
          this.providerData = resultFork[0];
          if (reload) {
            this.providerSelected = JSON.parse(sessionStorage.getItem(this.SESSION_STORAGE_LABELS.DEFAULT_PROVIDER_SELECTED));
          } else {
            this.providerSelected = resultFork[0] ? resultFork[0][1] : null;
            sessionStorage.setItem(this.SESSION_STORAGE_LABELS.DEFAULT_PROVIDER_SELECTED, JSON.stringify(this.providerSelected));
          }
          this.loaderService.display(false);
        }, error => {
          console.log(error);
          this.loaderService.display(false);
        });
  }

  updateProvider(event) {
    sessionStorage.setItem(this.SESSION_STORAGE_LABELS.DEFAULT_PROVIDER_SELECTED, JSON.stringify(event));
    this.resetSessionStorageFilters();
    this.router.navigate([this.LINKS.HOMEPAGE]);
  }
}
